import { render, staticRenderFns } from "./IssueReceipt.vue?vue&type=template&id=58683561&scoped=true&"
import script from "./IssueReceipt.vue?vue&type=script&lang=js&"
export * from "./IssueReceipt.vue?vue&type=script&lang=js&"
import style0 from "./IssueReceipt.vue?vue&type=style&index=0&id=58683561&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58683561",
  null
  
)

export default component.exports